import React from 'react';
import PropTypes from 'prop-types';
import MediaQueries from 'react-responsive';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import Spacing from '@marvelapp/marvel-ui/spacing';

import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import Image from 'marketing-website/components/modules/Image';
import RevealWrapper from 'marketing-website/components/wrappers/RevealWrapper';

export default function ImageBlock({ copy, title, artwork, isRightAligned }) {
  return (
    <RevealWrapper>
      <Grid columns={12} alignItems="center">
        <GridItem columnSpan={12} columnSpanM={6}>
          {isRightAligned ? (
            <div>
              <MediaQueries maxWidth={769}>
                <Spacing type="padding" size="m" position="bottom">
                  <Image {...artwork} hasShadow={false} />
                </Spacing>
              </MediaQueries>
              <HeadingBlock
                justifyM="start"
                justify="center"
                maxWidth={420}
                title={title}
                copy={copy}
                paragraphSize="m"
              />
            </div>
          ) : (
            <Image {...artwork} hasShadow={false} />
          )}
        </GridItem>

        <GridItem columnSpan={12} columnSpanM={6} alignContent="center">
          {isRightAligned ? (
            <MediaQueries minWidth={770}>
              <Image {...artwork} hasShadow={false} />
            </MediaQueries>
          ) : (
            <HeadingBlock
              maxWidth={420}
              paragraphSize="m"
              title={title}
              copy={copy}
            />
          )}
        </GridItem>
      </Grid>
    </RevealWrapper>
  );
}

ImageBlock.propTypes = {
  artwork: PropTypes.object,
  copy: PropTypes.string,
  color: PropTypes.string,
  title: PropTypes.string,
  paragraphSize: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl', 'xxl']),
  isRightAligned: PropTypes.bolean,
};

ImageBlock.defaultProps = {
  isRightAligned: false,
};



// WEBPACK FOOTER //
// ./src/pages/sketch/ImageBlock.js